import * as Sentry from '@sentry/ember';
import ApplicationInstance from '@ember/application/instance';
import config from 'scaleflow/config/environment';

// Route and runloop performance tracing. @sentry/ember 10 did this in its own
// instance initializer; 11 leaves it to the app. Only where Sentry is enabled,
// so tests never start async tracing that outlives their owner.
export function initialize(owner: ApplicationInstance) {
  if (config['@sentry/ember']?.sentry?.enabled) {
    Sentry.instrumentAppInstancePerformance(owner);
  }
}

export default {
  initialize,
};
